/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tag } from '../../models/tag';
import { TagApiRespModel } from '../../models/tag-api-resp-model';

export interface ApiMasterTagEditPost$Params {
      body?: Tag
}

export function apiMasterTagEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterTagEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TagApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTagEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagApiRespModel>;
    })
  );
}

apiMasterTagEditPost.PATH = '/api/Master/Tag/Edit';
